<style lang="scss" scoped>
    .progress-bar {
        color: $white;
        height: 100%;

        &__segment {
            display: flex;
            height: calc(#{percentage(1/3)} - 1.33333333px);

            &:last-of-type {
                height: 4px;
            }
            &-number,
            &-name,
            &-bar {
                flex: 0 0 auto;
            }
            &-number,
            &-name {
                font-size: toRem(20px);
                line-height: 4px;
                letter-spacing: 4px;
                text-transform: uppercase;
                font-weight: 300;
            }
            &-number {
                &.active {
                    font-weight: bold;
                }
            }
            &-name {
                @include link-colors($white, $white);
            }
            &-tail {
                height: 100%;
                position: relative;
                width: 1px;
                background-color: $white;

                &--active {
                    position: absolute;
                    height: 100%;
                    width: 4px;
                    transform: scaleY(0);
                    transform-origin: top;
                    transition: transform $transition-short;

                    &.active {
                        transform: scaleY(1);
                    }
                }
            }
            &-divider {
                position: absolute;
                width: 35px;
                height: 1px;
                background-color: $white;
                left: 50%;
                top: percentage(1 / 3);
                transform: translate(-50%, -50%);

                & + .progress-bar__segment-divider {
                    top: percentage(2 / 3);
                }
            }
            &-bar {
                position: relative;
                width: 60px;
                border-top: 4px solid;
                margin: 0 30px 0 15px;
                display: flex;
                flex-direction: column;
                align-items: center;
            }
        }
    }
</style>
<template>
    <div class="progress-bar">
        <div v-for="(progress, i) in progressData" :key="`${progress.name}-${i}`" class="progress-bar__segment">
            <div class="progress-bar__segment-number" :class="i === currentProgress ? 'active' : ''">0{{ i + 1 }}</div>
            <div class="progress-bar__segment-bar" :style="{borderColor: progress.color}">
                <template v-if="i < progressData.length - 1">
                    <div class="progress-bar__segment-tail" >
                        <div class="progress-bar__segment-divider"></div>
                        <div class="progress-bar__segment-divider"></div>
                    </div>
                    <div class="progress-bar__segment-tail--active" :class="{active: i <= currentProgress - 1}" :style="{backgroundColor: progress.color}"></div>
                </template>
            </div>
            <template v-if="links[i]">
                <router-link :to="links[i]" v-if="i <= currentProgress" class="progress-bar__segment-name">{{ titleOverrides[i] || progress.name }}</router-link>
            </template>
            <template v-else>
                <div v-if="i <= currentProgress" class="progress-bar__segment-name">{{ titleOverrides[i] || progress.name }}</div>
            </template>
        </div>
    </div>
</template>
<script>
export default {
    name: 'ProgressBar',
    props: {
        progressData: {
            type: Array,
            required: true,
        },
        currentProgress: {
            type: Number,
            default: 0,
        },
        titleOverrides: {
            type: Array,
            default: () => [],
        },
        links: {
            type: Array,
            default: () => [],
        },
    },
}
</script>
